import OrderExportField from "@/services/api/moreFeatures/orderExport/enum/Fields";

/**
 * 根据 【列表中的导出项顺序】 对 【发生变化值的数组】 进行排序
 */
export function sortOrderExportFields(
    orderExportFields: OrderExportField[],
    fieldsToSort: OrderExportField[] = [],
): OrderExportField[] {
    /** 目前显示中的列表indexMap */
    const indexMap = new Map<OrderExportField, number>();
    orderExportFields.forEach((field, index) => {
        indexMap.set(field, index);
    });

    const withSortKeys = [...fieldsToSort].map((field) => ({
        field,
        index: indexMap.has(field) ? indexMap.get(field)! : Infinity,
    }));

    withSortKeys.sort((a, b) => {
        return a.index - b.index;
    });

    return withSortKeys.map((item) => item.field);
}
